import { get } from '../../http';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getAdUsers ({ rootState }) {
    // const global = rootState.login.adType !== 'radio' ? 'global/ads' : 'ads/ad'
    const res = await get(`/agency/ads/ad/adselect`);
    return res.data;
  },
  async getOrderById ({ state, commit }, id) {
    const res = await get(`/agency/order/${id}`);
    return res.data;
  },
  async getOrderListByAdUserId ({ state, commit, rootState }, id) {
    const global = rootState.login.adType !== 'radio' ? 'global-order' : 'order'
    const params = {}

    if (rootState.login.adType === 'global') {
      params.medias = -1
    }

    const res = await get(`/agency/${global}/get-orders-for-ad/${id}`, params);
    return res.data;
  },
  async getOrderData ({ state, commit, rootState }, id) {
    const global = rootState.login.adType !== 'radio' ? 'global-order' : 'order'
    const params = {}

    if (rootState.login.adType === 'global') {
      params.medias = -1
    }

    const res = await get(`/agency/${global}/get-order-info/${id}`, params);
    return res.data;
  },
  async getVerifyList ({ state, rootState }, params) {
    const global = rootState.login.adType !== 'radio' ? 'global/' : ''

    if (rootState.login.adType === 'global') {
      params.medias = -1
    }

    const res = await get(`/agency/${global}ads/verify-list`, params)
    return res.data
  },
  async getAdList ({ state, rootState, commit }, params) {
    rootState.global.advertise.page.loading = true;
    const global = rootState.login.adType !== 'radio' ? 'global/' : ''

    if (rootState.login.adType === 'global') {
      params.medias = -1
    }

    const res = await get(`/agency/${global}ads`, params);
    const {
      data: { data, total },
      header
    } = res.data;
    rootState.global.advertise.page.setPageData(
      {
        header,
        data: data.data.map(item => ({ ...item, editing: false })),
        total: data.total
      },
      false
    );
    return total;
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
